import React from "react";
import { Link } from "gatsby";
import Seo from "../components/seo";
import useIsInViewport from "../hooks/useIsInViewport";
import { isEven } from "../helpers/helpers";
import furnatura from "../img/hp/furnatura.jpg";
import joalis from "../img/hp/joalis.png";
import biocultus from "../img/hp/biocultus.jpg";
import gambod from "../img/hp/gambod.png";
//import boxSmall from "../img/hp/krabice-mala.jpg";
import mpm from "../img/hp/mpm.png";
import code8 from "../img/hp/nav1.jpg";
import ourWork from "../img/hp/nav2.jpg";
import testCoverage from "../img/hp/test-coverage.png";
import nanits from "../img/hp/nanits.jpg";
import prague from "../img/hp/nav4.jpg";
import rocket8 from "../img/hp/rocket8.png";
import napraia from "../img/hp/napraia.jpg";

const news = [
        {
        imgSrc: napraia,
        alt: "Na Praia",
        ribbon: "Live!",
        link: "https://www.napraia.com",
        linkText: "Na Praia",
        text: "Nestled between ocean waves and a wild nature reserve, on pristine dunes just north of Comporta, lies a vision over a decade in the making. A hotel where life is informed by the gentle rhythm of the ocean, and where there is time and space for connection.",
        ctaText: "Go & wonder!",
    },
    {
        imgSrc: biocultus,
        alt: "Biocultus",
        ribbon: "Launched!",
        link: "https://www.biocultus.cz",
        linkText: "Biocultus",
        text: "We developed a modern e-shop for Biocultus to showcase their world-class Finnish composting systems. Built on the custom <a href=\"https://shop8.cz/\" target=\"_blank\" rel=\"noopener noreferrer\">Shop8</a> platform with a <a href=\"https://nextjs.org/\" target=\"_blank\" rel=\"noopener noreferrer\">Next.js</a> frontend, the site offers fast performance, supports multiple countries, languages, and currencies, and delivers a seamless international shopping experience.",
        ctaText: "Explore the Future of Sustainable Living!",
    },
    /*     {
            imgSrc: gambod,
            alt: "Gambod Database",
            ribbon: "Launched!",
            link: "https://gsacom.com/gambod/",
            linkText: "GAMBoD Database",
            text: "The exclusive GAMBoD databases give Members and Associates unmatched access to global industry data on devices, spectrum, networks, chipsets, and operators-updated regularly by our research team and used for insightful reports.",
            ctaText: "Learn more",
        }, */
     {
        imgSrc: furnatura,
        alt: "Furnatura",
        ribbon: "Launched!",
        link: "https://www.furnatura.com",
        linkText: "Furnatura",
        text: "Furnatura is a Czech brand specializing in natural, eco-friendly cosmetics for dogs. Founded based on over 10 years of experience in running a professional dog grooming salon (Dogtown) in Prague, the brand focuses on developing products that are gentle on dogs and environmentally friendly. ",
        ctaText: "Have a look",
    },
    /*     {
        imgSrc: joalis,
        alt: "Joalis",
        ribbon: "Launched!",
        link: "https://www.joalis.cz",
        linkText: "Joalis website",
        text: "Joalis produces unique natural food supplements which combine the effects of herbs and plants with the power of information. We've been commissioned to deliver this awesome project from A-Z and we hope you like the results.",
        ctaText: "Have a look",
    },
     {
            imgSrc: rocket8,
            alt: "Box small",
            ribbon: "News",
            link: "https://www.shop8.cz",
            linkText: "When off-the-shelf software feels too restrictive",
            text: "We've built a modular digital commerce solution to save cost, speed up go-to-market and offer our clients tailored high performing shopping experience. We've gathered a lot of skills over the years - this is where it all comes together. powerful backoffice on one end, performant front-shop / mobile app on the other.",
            ctaText: "Our e-commerce solution",
        }, */
/*     {
        imgSrc: mpm,
        alt: "Mobile Phone Museum",
        ribbon: "Launched!",
        link: "https://www.mobilephonemuseum.com/catalogue/",
        linkText: "Museum of Mobile Phones",
        text: 'In collaboration with British and Czech collectors and enthusiasts an amazing project of the largest collection of mobile phones in the world was created. A neat design job provided by folks from <a href="https://www.toman-design.com">Toman Design</a> brought to life with CMS and static site generator.',
        ctaText: "Check this out!",
    }, */
];
const intro = [
    {
        imgSrc: ourWork,
        alt: "Our work",
        link: "/about/",
        linkText: "We’re a dedicated team of experts",
        text: "Having previously worked both client-side and in agency environments in the UK, we understand how different teams like to operate and how this has evolved over the years.",
        ctaText: "More about us",
    },
    {
        imgSrc: code8,
        alt: "Code8",
        link: "/approach/",
        linkText: "A remote team that feels anything but remote",
        text: "Remote teams are commonplace today, but not many offer the feeling of having your team in house. We ensure we keep communication high so it’s as if we are right there with you.",
        ctaText: "Our approach",
    },
    {
        imgSrc: testCoverage,
        alt: "Test coverage",
        link: "/approach/",
        linkText: "We enjoy a good night's sleep",
        text: "That's why we test our code from early on. It brings about peace of mind. It gives us confidence. And it helps our clients scale their businesses smoothly.",
        ctaText: "See how we approach testing",
    },
    {
        imgSrc: nanits,
        alt: "Nanits",
        link: "/services/",
        linkText: "We don’t profess to do everything",
        text: "But we’ve become specialists in many areas that we think are valuable to a wide range of businesses, and our skill sets are constantly growing.",
        ctaText: "What we do",
    },
    {
        imgSrc: prague,
        alt: "Prague",
        link: "/contact/",
        linkText: "We’d like to hear from you",
        text: "We’re based in Prague, but we want to feel like we’re right next door.",
        ctaText: "Get in touch",
    },
];

const Index = () => {
    const { setRef } = useIsInViewport();
    return (
        <>
            <Seo title="Code 8 presents..." />
            <h2 className="line animate-1">Recently launched</h2>
            <div className="news">
                {news.map((item, index) => (
                    <article className="article2" ref={setRef} data-observer={index} key={item.alt}>
                        <div className="left animate-2">
                            <img src={item.imgSrc} alt={item.alt} />
                        </div>
                        <div className={"right"}>
                            <h3 className="animate-3">
                                <a href={item.link} target="_blank" rel="noopener noreferrer">
                                    {item.linkText}
                                </a>
                            </h3>
                            <p className="animate-4" dangerouslySetInnerHTML={{ __html: item.text }}></p>
                            <p className="animate-5">
                                <a href={item.link} target="_blank" rel="noopener noreferrer">
                                    {item.ctaText}
                                </a>
                            </p>
                        </div>
                    </article>
                ))}
            </div>
            <h2 className="line animate-1" ref={setRef} data-observer={4}>
                Who are we?
            </h2>
            <div className="intro">
                {intro.map((item, index) => (
                    <article className="article" ref={setRef} data-observer={index + 5} key={item.alt}>
                        {!isEven(index) && (
                            <div className="left animate-2" style={{ backgroundImage: `url('${item.imgSrc}')` }}>
                                <img src={item.imgSrc} alt="Code8" />
                            </div>
                        )}
                        <div className={`${isEven(index) ? "left animate-3" : "right animate-2"}`}>
                            <h3 className={`${isEven(index) ? "animate-4" : "animate-3"}`}>
                                <Link to={item.link}>{item.linkText}</Link>
                            </h3>
                            <p className={`${isEven(index) ? "animate-5" : "animate-4"}`} dangerouslySetInnerHTML={{ __html: item.text }}></p>
                            <p className={`${isEven(index) ? "animate-6" : "animate-5"}`}>
                                <Link to={item.link}>{item.ctaText}</Link>
                            </p>
                        </div>
                        {isEven(index) && (
                            <div className="right animate-6" style={{ backgroundImage: `url('${item.imgSrc}')` }}>
                                <img src={item.imgSrc} alt="Code8" />
                            </div>
                        )}
                    </article>
                ))}
            </div>
        </>
    );
};
export default Index;
